import {createContext} from 'react'

function noop() {}

export const AuthContext = createContext({
  authData: {},
  login: noop,
  logout: noop,
  isAuthenticated: false
})
